import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from '../actions/index'
import Skeleton from 'react-loading-skeleton'
import DropdownTreeSelect from "react-dropdown-tree-select"
import { cloneDeep } from 'lodash'
import geosData from "../data/geos.json"
import aoisData from "../data/aois.json"
import contentTypesData from "../data/contentTypes.json"
import industriesData from "../data/industries.json"
import topicsData from "../data/Topics.json"
import { EmailAlertSetup } from './EmailAlertSetup'
import { currentUtcDateTime } from '../utils/dateTime'
import { MAXCONTENTSETLIMIT } from "../utils/constants"
import { pushContentToMatomo } from "../utils/matomo"
import { Redirect } from 'react-router-dom'
import Message from './Message'
import { validateName } from '../utils/validations'

export class ContentSet extends Component {

    constructor(props) {
        super(props);

        this.state = this.initialState;        
    }

    get initialState() {
        return {
            id: 0,
            name: '',
            geographies: [],
            aois: [],
            industries: [],
            contentTypes: [],
            topics: [],
            geosToDisplay: this.sortGeographies(geosData),
            aoisToDisplay: aoisData.sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
            industriesToDisplay: industriesData.sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
            contentTypesToDisplay: contentTypesData.filter(x => x.id === 4 || x.id === 5 || x.id === 7).sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
            topicsToDisplay: topicsData.sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
            aoisPlaceHolder: '0 filter(s) applied',
            industriesPlaceHolder: '0 filter(s) applied',
            geosPlaceHolder: '0 filter(s) applied',
            contentTypesPlaceHolder: '0 filter(s) applied',
            instantAlert: false,
            dailyWrapUpAlert: true,
            dailyWrapUpAlertTime: '-1',
            dailyWrapUpPrimaryFilter: '1',
            dailyWrapUpSecondaryFilter: '2',
            errors: {},
            successMessage: ''
        }
    }

    sortGeographies(geoList) {
        if (geoList != undefined) {
            geoList = geoList.sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label))

            geoList.forEach(item => item.children = this.sortGeographies(item.children))
        }

        return geoList
    }

    updateInitialState(currentPaddleId) {
        let currentPreference = this.props.preferences.alertPreferences.filter(x => x.id === Number(currentPaddleId))

        if (currentPreference !== undefined) {
            this.setState({
                ...this.state,
                id: currentPreference[0].id,
                name: currentPreference[0].name,
                geographies: currentPreference[0].geographies.map(item => { return { id: item.id, label: item.name } }),
                aois: currentPreference[0].areasOfInterest.map(item => { return { id: item.id, label: item.name } }),
                industries: currentPreference[0].industries.map(item => { return { id: item.id, label: item.name } }),
                contentTypes: currentPreference[0].contentTypes.map(item => { return { id: item.id, label: item.name } }),
                topics: currentPreference[0].topics.map(item => { return { id: item.id, label: item.name } }),
                geosToDisplay: geosData.sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
                aoisToDisplay: contentTypesData.filter(x => x.id === 4 || x.id === 5 || x.id === 7).sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
                contentTypesToDisplay: contentTypesData.filter(x => x.id === 4 || x.id === 5 || x.id === 7).sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
                industriesToDisplay: industriesData.sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)),
                topicsToDisplay: topicsData.sort((a,b)=>a.label != null && b.label != null && a.label.localeCompare(b.label)),
                instantAlert: currentPreference[0].instantAlert,
                dailyWrapUpAlert: currentPreference[0].dailyWrapUpAlert,
                dailyWrapUpAlertTime: currentPreference[0].dailyWrapUpAlertTime,
                dailyWrapUpPrimaryFilter: currentPreference[0].dailyWrapUpPrimaryFilter,
                dailyWrapUpSecondaryFilter: currentPreference[0].dailyWrapUpSecondaryFilter
            })

            this.bindControls()
        }
    }

    bindControls() {
        this.contentSetName.value = this.state.name
        this.saveAOIs("", this.state.aois)
        this.saveIndustries("", this.state.industries)
        this.saveGeos("", this.state.geographies)
        this.saveContentTypes("", this.state.contentTypes)
        this.saveTopics("", this.state.topics)
    }

    componentDidMount() {
        if (this.props.user) {
            this.props.onFetch().then(() => {
                if (this.props.preferences.alertPreferences.length != 0) {
                    if (this.props.match.params.id !== undefined)
                        this.updateInitialState(this.props.match.params.id)
                }
            })
        }

        window.scrollTo(0, 0)
    }

    componentDidUpdate(prevProps, prevState) {
        const errors = this.state.errors
        if (errors !== prevState.errors && Object.keys(errors).length > 0) {
            window.scrollTo(0, 0);
        }
    }

    updateSelectedNodes = (id) => obj => {
        if (obj.id === id)
            obj.checked = true
        else if (obj.children)
            obj.children.forEach(this.updateSelectedNodes(id))
    }

    isValid = () => {
        let errors = {};
        if (!this.state.dailyWrapUpAlertTime || this.state.dailyWrapUpAlertTime == '-1') {
            errors["dailyAlertTime"] = 'If you choose an alert type of "Daily Wrap-up", you must set a delivery time.'
        }
        const contentSetNameValidationError = validateName(this.state.name, 'content set')

        if (contentSetNameValidationError) {
            errors["contentSetName"] = contentSetNameValidationError
        }
        this.setState({ errors: errors })
        if (Object.keys(errors).length > 0) {
            return false
        }
        return true
    }

    save = (e) => {
        //Save only if form is valid
        if (this.isValid()) {
            let maxId = Math.max(...this.props.preferences.alertPreferences.map(o => o.id), 0)

            let newAlertPreferenceObj =
            {
                id: this.state.id === 0 ? (Number(maxId) + 1) : this.state.id,
                name: this.state.name,
                type: 'General',
                majorDealPreference: false,
                areasOfInterest: this.state.aois,
                geographies: this.state.geographies,
                industries: this.state.industries,
                contentTypes: this.state.contentTypes,
                topics: this.state.topics,
                instantAlert: this.state.instantAlert,
                dailyWrapUpAlert: this.state.dailyWrapUpAlert,
                dailyWrapUpAlertTime: this.state.dailyWrapUpAlertTime,
                dailyWrapUpPrimaryFilter: this.state.dailyWrapUpPrimaryFilter,
                dailyWrapUpSecondaryFilter: this.state.dailyWrapUpSecondaryFilter,
                dateModified: currentUtcDateTime()
            }

            let finalAlertPreferences
            let successMsg = ''

            // create new content set
            if (this.state.id === 0) {
                this.setState({ id: Number(maxId) + 1 })

                finalAlertPreferences = [...this.props.preferences.alertPreferences, newAlertPreferenceObj]

                successMsg = 'Your content set and any selected alerts have been successfully created.'
                this.pushToMatomo("contentset_savenew")
            }
            else {  // edit content set
                finalAlertPreferences = this.props.preferences.alertPreferences.map(preference =>
                    preference.id === this.state.id ?
                        newAlertPreferenceObj : preference);

                successMsg = 'Edits to your content set and/or alerts have been successfully saved.'
                this.pushToMatomo("contentset_saveexisting")
            }

            const request = () => {
                return {
                    ...this.props.preferences,
                    alertPreferences: finalAlertPreferences
                }
            }

            this.props.onSubmit(request()).then(() => {
                if (this.props.preferences.error === '') {
                    this.setState({ successMessage: successMsg })
                }
                else {
                    this.props.preferences.error = ''
                }
            })
        }
    }

    pushToMatomo = (uiEvent) => {
        var primaryFilter = this.state.dailyWrapUpPrimaryFilter == 1? "Area of Interest" : 
            this.state.dailyWrapUpPrimaryFilter == 2 ? "Industry": 
            this.state.dailyWrapUpPrimaryFilter == 3 ? "Geography": ""

        var secondaryFilter = this.state.dailyWrapUpSecondaryFilter == 1? "None" : 
            this.state.dailyWrapUpPrimaryFilter == 2 ? "Content Type": 
            this.state.dailyWrapUpPrimaryFilter == 3 ? "Area of Interest": 
            this.state.dailyWrapUpPrimaryFilter == 4 ? "Industry": 
            this.state.dailyWrapUpPrimaryFilter == 5 ? "Geography": ""

        var contextData = {
            "aoi": this.state.aois,
            "industry": this.state.industries,
            "geo": this.state.geographies,
            "contentType": this.state.contentTypes,
            "topics": this.state.topics,
            "instantAlert": this.state.instantAlert,
            "dailyWrapUpAlert": this.state.dailyWrapUpAlert,
            "dailyAlertTime": this.state.dailyWrapUpAlertTime,
            "primaryHeading": primaryFilter,
            "secondaryHeading": secondaryFilter
        }

        pushContentToMatomo(uiEvent,"personalize","custom_contentset", "click", "save", contextData)
    }

    expandGeographies(parentItem, newGeosToDisplay, currentNode) {

        newGeosToDisplay.forEach((item) => {
            if (item.id == currentNode.id || item.id == currentNode._parent) {
                if(parentItem != undefined)
                    parentItem.expanded = true
                item.expanded = true
            }
            if (item.children != undefined)                
                this.expandGeographies(item, item.children, currentNode)
        })
    }

    saveGeos = (currentNode, selectedNodes) => {
        let newGeosToDisplay = cloneDeep(geosData)
        let result = selectedNodes.map(item => {
            newGeosToDisplay.forEach(this.updateSelectedNodes(item.id))
            return { id: item.id, name: item.label }
        })

        this.expandGeographies(undefined, newGeosToDisplay, currentNode)

        this.setState({
            geographies: result,
            geosToDisplay: newGeosToDisplay,
            geosPlaceHolder: selectedNodes.length + ' filter(s) applied'
        })
    }

    saveAOIs = (currentNode, selectedNodes) => {
        let newAoisToDisplay = cloneDeep(aoisData)
        let result = selectedNodes.map(item => {
            newAoisToDisplay.forEach(this.updateSelectedNodes(item.id))
            return { id: item.id, name: item.label }
        })

        this.setState({
            aois: result,
            aoisToDisplay: newAoisToDisplay,
            aoisPlaceHolder: selectedNodes.length + ' filter(s) applied'
        })
    }

    saveContentTypes = (currentNode, selectedNodes) => {
        let newContentTypesToDisplay = cloneDeep(contentTypesData.filter(x => x.id === 4 || x.id === 5 || x.id === 7))
        let result = selectedNodes.map(item => {
            newContentTypesToDisplay.forEach(this.updateSelectedNodes(item.id))
            return { id: item.id, name: item.label }
        })

        this.setState({
            contentTypes: result,
            contentTypesToDisplay: newContentTypesToDisplay,
            contentTypesPlaceHolder: selectedNodes.length + ' filter(s) applied'
        })
    }

    saveIndustries = (currentNode, selectedNodes) => {
        let newIndustriesToDisplay = cloneDeep(industriesData)
        let result = selectedNodes.map(item => {
            newIndustriesToDisplay.forEach(this.updateSelectedNodes(item.id))
            return { id: item.id, name: item.label }
        })

        this.setState({
            industries: result,
            industriesToDisplay: newIndustriesToDisplay,
            industriesPlaceHolder: selectedNodes.length + ' filter(s) applied'
        })
    }

    saveTopics = (currentNode, selectedNodes) => {
        let newTopicsToDisplay = cloneDeep(topicsData)
        let result = selectedNodes.map(item => {
            newTopicsToDisplay.forEach(this.updateSelectedNodes(item.id))
            return { id: item.id, name: item.label }
        })

        this.setState({
            topics: result,
            topicsToDisplay: newTopicsToDisplay            
        })       
    }    

    removeTopicId = (id) => {        
        let topics = this.state.topics.filter(item => item.id !== id)
        let newTopicsToDisplay = this.state.topicsToDisplay
        let obj = newTopicsToDisplay.find(item => item.id === id)
        if(obj) obj.checked = false;
        this.setState({
            topics: topics,
            topicsToDisplay: newTopicsToDisplay            
        })
    }

    updateEmailAlertSetupState = (instantAlert, dailyWrapUpAlert, dailyWrapUpAlertTime, dailyWrapUpPrimaryFilter, dailyWrapUpSecondaryFilter) => {
        //reset the validation error 
        if (dailyWrapUpAlertTime || dailyWrapUpAlertTime != '-1') {
            let errorObj = this.state.errors
            delete errorObj.dailyAlertTime
            this.setState({ errors: errorObj })
        }
        this.setState(
            {
                instantAlert: instantAlert,
                dailyWrapUpAlert: dailyWrapUpAlert,
                dailyWrapUpAlertTime: !dailyWrapUpAlert && dailyWrapUpAlertTime == '-1' ? '18:00' : dailyWrapUpAlertTime,
                dailyWrapUpPrimaryFilter: !dailyWrapUpAlert ? '1' : dailyWrapUpPrimaryFilter,
                dailyWrapUpSecondaryFilter: !dailyWrapUpAlert ? '2' : dailyWrapUpSecondaryFilter
            }
        )
    }

    updateNameState = (e) => {
        const contentSetName = e.target.value
        this.setState({ name: contentSetName.trim() })
        //reset the validation error 
        const contentSetNameValidationErrors = validateName(contentSetName, 'content set')
        if (!contentSetNameValidationErrors) {
            let errorObj = this.state.errors
            delete errorObj.contentSetName
            this.setState({ errors: errorObj })
        }
    }

    clearState = () => {
        this.setState(this.initialState);
    }

    render() {

        if (this.props.user != null) {
            if (this.props.preferences.error != '') {
                this.props.preferences.error = ''
                return <Redirect to='/error' />
            }
            else {
                if (this.props.preferences.alertPreferences.length >= MAXCONTENTSETLIMIT && this.props.match.params.id === undefined) {
                    return (
                        <Message url='personalize' buttonText='View Content Sets'>
                            <h1 className="section-header">Maximum number of content sets reached</h1>
                            <p>You have reached the maximum number of permitted content sets.</p>
                            <p>Please view your created content sets on the Content Sets and Alerts page and edit or delete these in order to create more space.</p>
                        </Message>
                    )
                }
                else {
                    if (this.props.preferences.alertPreferences.length != 0) {                       
                        const errors = this.state.errors
                        return (
                            <div className='content content-set grid-content-full'>
                                <div className='inner-container'>
                                    <h1 className="section-header">Content and Alert Selection</h1>
                                    <p>Build a customized content set and select your email alerts. You can build multiple content sets.<br /></p>
                                    {Object.keys(errors).length > 0 &&

                                        <div className='alert alert-error'>
                                            <p>{this.state.errors["dailyAlertTime"]}</p>
                                            <p dangerouslySetInnerHTML={{ __html: this.state.errors["contentSetName"] }}></p>
                                        </div>}
                                    <div className='line' />
                                </div>
                                {this.state.successMessage !== '' ?
                                    <div className='inner-container content-set-saved'>
                                        <br />
                                        <div className="success-wrapper">
                                            <div className='success-icon'></div>
                                        </div>
                                        <div className="message-wrapper">
                                            <div className=''>{this.state.successMessage}</div>
                                            <br />
                                            <div className='cta-action-container'>
                                                <span title={this.props.preferences.alertPreferences.length >= MAXCONTENTSETLIMIT
                                                    ? 'you have reached the maximum number of content sets' : 'create content set'}>
                                                    <a id='btnCreate' href={`/#/contentSet`} name='btnCreate'
                                                        disabled={this.props.preferences.alertPreferences.length >= MAXCONTENTSETLIMIT ? true : false}
                                                        className='pure-button secondary-action' onClick={event => this.clearState()}>Create New Content Set</a>
                                                </span>
                                                <a className='pure-button primary-action' href={`/#/personalize`} target='_self' >View Content Set List</a>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className='inner-container content-set-create'>
                                        <h3>Curate your content set</h3>
                                        <p>MLex content is primarily organized into different Areas of Interest (AOI) that cover the main elements of regulatory risk.  When creating a new customized content set, the filters are set to include all content by default (‘0 filters applied’).  Narrow what you see in this content set by selecting one or more options from the available filters.</p>
                                        <div id="collapseLink">
                                            <input type="checkbox" id="cb1_aoi_help" /><label htmlFor="cb1_aoi_help">What are AOI's?</label>
                                            <div id="aoi_help_container">
                                                <h5>Areas of Interest (AOI)</h5>
                                                <h6>Antitrust</h6>
                                                <p>Enforcement of antitrust/competition law rules and case law developments that impact how authorities enforce.  Litigation in courts and changes in antitrust policy.</p>
                                                <h6>Data Privacy and Security</h6>
                                                <p>Data protection and security legislation and enforcement, plus court litigation against companies that breach laws.</p>
                                                <h6>Energy</h6>
                                                <p>Coverage relating to law making and changes to existing regulation, in the European energy sector.</p>
                                                <h6>Financial Crime</h6>
                                                <p>Enforcement of anti-bribery laws, investigations and court litigation.  Banking/financial services financial crime investigations, e.g. money-laundering, fraud, market manipulation.</p>
                                                <h6>Financial Services</h6>
                                                <p>Coverage relating to law making and changes to existing regulation, in the European and US financial services sectors.</p>
                                                <h6>Mergers and Acquisitions</h6>
                                                <p>The steps and hurdles for mergers requiring regulatory review and clearance.  Case law developments impacting M&A reviews and changes in M&A policy.</p>
                                                <h6>State Aid</h6>
                                                <p>Investigations initiated by the European Commission to establish whether assistance offered (e.g. tax rebates, grants, etc.) to specific companies breaches EU rules.</p>
                                                <h6>Technology</h6>
                                                <p>Global content relating to the regulation of technology, platforms and telecommunications.</p>
                                                <h6>Trade</h6>
                                                <p>Trade negotiations, trade disputes and enforcement.  Particularly US Federal-level trade enforcement and litigation and EU enforcement of trade defense rules and follow-on litigation.</p>
                                            </div>
                                        </div>
                                        <div className='inner-container'>
                                            <h5>Filter by:</h5>
                                            <p>Choose filters by manually selecting from the drop-down menu or type to show suggested matches.<br /></p>
                                            <div className='filters_container'>
                                                <div className='filters_container_item'><span className='filter_label'>Area of Interest (AOI)</span>
                                                    <DropdownTreeSelect id="AOIs" name="AOIs" data={this.state.aoisToDisplay} showPartiallySelected={true} inlineSearchInput={false} onChange={this.saveAOIs} texts={{ placeholder: this.state.aoisPlaceHolder }} /></div>
                                                <div className='filters_container_item'><span className='filter_label'>Industry</span>
                                                    <DropdownTreeSelect id="Industries" name="Industries" data={this.state.industriesToDisplay} showPartiallySelected={true} inlineSearchInput={false} onChange={this.saveIndustries} texts={{ placeholder: this.state.industriesPlaceHolder }} /></div>
                                                <div className='filters_container_item'><span className='filter_label'>Geography</span>
                                                    <DropdownTreeSelect id="Geos" name="Geos" data={this.state.geosToDisplay} showPartiallySelected={true} inlineSearchInput={false} onChange={this.saveGeos} texts={{ placeholder: this.state.geosPlaceHolder }} /></div>
                                            </div>
                                            <div className='dropdown-vertical-spacing'></div>
                                            <div className='filters_container contenttype-filter'>
                                                <div className='filters_container_item'>
                                                    <span className='filter_label'>Content Type</span>
                                                    <span className='info-icon tooltip bottom' aria-label='Comment: Deep-dive analysis and commentary &nbsp;&nbsp; | &nbsp;&nbsp; Insight: News story &nbsp;&nbsp; | &nbsp;&nbsp; Official Statement: Third-party documents published with an MLex summary'></span>
                                                    <DropdownTreeSelect id="Contyps" name="Contyps" data={this.state.contentTypesToDisplay} showPartiallySelected={true} inlineSearchInput={false} onChange={this.saveContentTypes} texts={{ placeholder: this.state.contentTypesPlaceHolder }} /></div>
                                            </div>                                          
                                            <div className='dropdown-vertical-spacing'></div>
                                            <div className='filters_container topics-filter'>
                                                <div className='filters_container_item'>
                                                    <span className='filter_label'>Topic</span>
                                                    <span className='info-icon tooltip bottom' aria-label='The drop-down menu does not show all available topics.  Type a partial or full topic name in the drop-down menu to show all matching tags that you can then select.'></span>
                                                    <div className='topics-section'>                                                  
                                                        {this.state.topics
                                                            .map(item => (<span key={item.id}  className='topic-tags'>{item.name}<span className='remove-button' onClick={event => this.removeTopicId(item.id)}></span></span>))                                                                                                                
                                                        }
                                                    </div>
                                                    <DropdownTreeSelect id="Topics" name="topics" className="select_topics" data={this.state.topicsToDisplay} onChange={this.saveTopics} texts={{ placeholder: 'Type to search, click/tap to select' }} keepTreeOnSearch={true} />                                                    
                                                </div>                                                    
                                            </div>                                                                                  
                                        </div>
                                        <div className='line'></div>
                                        <div>
                                            <EmailAlertSetup data={this.state} callFunc={this.updateEmailAlertSetupState} />
                                        </div>
                                        <div className='line'></div>
                                        <div className="content-set-name">
                                            <h3>Give your content set a meaningful name</h3>
                                            <strong><span className='font-small'>Name<span className='mandatory'>*</span></span></strong>
                                            <br />
                                            <input className={`input ${this.state.errors["contentSetName"] ? 'error-input' : ''}`} type='text' id='contentSetName'
                                                ref={input => { this.contentSetName = input }}
                                                placeholder='Name your content set e.g. Antitrust - Europe' maxLength="48"
                                                onChange={this.updateNameState} />
                                            <br />
                                            <em className='font-small input-help'>Allowed characters: a-z A-Z 0-9 - . _ ( ) ' " ! : , & * [ ]</em>
                                            <br />
                                            <br />
                                            <span className='font-small'><span className='mandatory'>*</span> Denotes a required field</span>
                                        </div>
                                        <div className='inner-container button-container cta-action-container'>
                                            <a className='pure-button secondary-action' href={`/#/Personalize`} target='_self' 
                                            data-gm-u-pn="personalize"  
                                            data-gm-u-c="custom_contentset"
                                            data-gm-u-e="contentset_cancelnew" 
                                            data-gm-u-v="cancel"
                                            data-gm-u-a="click">Cancel</a>
                                            <button id='SaveButton' name='SaveButton' className='pure-button primary-action' onClick={event => this.save(event)}>Save</button>
                                        </div>
                                    </div>}
                            </div>
                        )
                    } else {
                        return <Skeleton count={5} />
                    }
                }
            }
        } else {
            return (<div />)
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        preferences: state.userPreferences
    }
}

const mapDispatchToProps = (dispatch) => ({
    onFetch: () => new Promise((resolve, reject) => {
        dispatch(actions.fetchPreferences()).then(() => {
            resolve();
        })
    }),

    onSubmit: (request) => new Promise((resolve, reject) => {
        dispatch(actions.updatePreferences(request)).then(() => {
            resolve();
        })
    })
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContentSet)